import { render } from "./TheFooter.vue?vue&type=template&id=f3f0cbc8&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=f3f0cbc8&lang=scss&scoped=true"

import exportComponent from "D:\\DOWNLOAD\\vue\\portfolio_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3f0cbc8"]])

export default __exports__